import React from 'react'

import Form from '@managers/Form'
import { Status } from '@features/inquiries'
import { IntegerField, RadioField } from '@components/Fields'
import { EllipsisLoader } from '@components/Loaders'

interface IProps {
  status: Status
}

class AffordabilityCalculatorSections extends Form<IProps> {
  formEl: Element | null = null

  render() {
    const { status } = this.props
    const { fields } = this.state
    const noOfApplicants = fields.num_applicants.value
    const hasTwoApplicants = noOfApplicants === '2'
    const noOfDependants = fields.num_dependants.value

    return (
      <form className="Form" autoComplete="off" onSubmit={this.handleSubmit}>
        <IntegerField
          optional
          field={fields.property_purchase_price}
          name="property_purchase_price"
          label="House price"
          icon={<i className="fas fa-pound-sign" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        <IntegerField
          field={fields.deposit}
          name="deposit"
          label="How much will you invest?"
          info="What will your initial investment be?"
          icon={<i className="fas fa-pound-sign" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        <RadioField
          field={fields.num_applicants}
          label="Number of adult residents"
          name="num_applicants"
          options={[
            {
              label: 'One',
              value: '1'
            },
            {
              label: 'Two',
              value: '2'
            }
          ]}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        <IntegerField
          name="applicant_1_annual_gross_income"
          label="Adult One Annual income (before tax)"
          field={fields.applicant_1_annual_gross_income}
          icon={<i className="fas fa-pound-sign" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        {hasTwoApplicants ? (
          <IntegerField
            name="applicant_2_annual_gross_income"
            label="Adult Two Annual income (before tax)"
            field={fields.applicant_2_annual_gross_income}
            icon={<i className="fas fa-pound-sign" />}
            onFocus={this.handleFieldFocus}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
          />
        ) : null}

        <IntegerField
          name="num_dependants"
          label="Number of children"
          field={fields.num_dependants}
          icon={<i className="fas fa-child" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        {noOfDependants > 0 ? (
          <IntegerField
            name="monthly_child_care_costs"
            label="Monthly childcare costs"
            field={fields.monthly_child_care_costs}
            icon={<i className="fas fa-pound-sign" />}
            onFocus={this.handleFieldFocus}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
          />
        ) : null}

        <IntegerField
          name="monthly_loan_payments"
          label="Monthly payments on all loans"
          field={fields.monthly_loan_payments}
          icon={<i className="fas fa-pound-sign" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        <IntegerField
          name="monthly_other_outgoings"
          label="Other monthly commitments (e.g. school fees)"
          field={fields.monthly_other_outgoings}
          info="Make sure you have NOT included any regular living costs (such as food, clothing, commute) in the calculator. We make allowances for them separately."
          icon={<i className="fas fa-pound-sign" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />

        <div className="Row -align-right">
          <button
            type="submit"
            className={`no-disable-on-submit Button ${
              status === 'CALCULATING' ? '-secondary' : '-primary'
            }`}
          >
            {status === 'CALCULATING' ? <EllipsisLoader color="white" /> : 'Calculate'}
          </button>
        </div>
      </form>
    )
  }
}

export default AffordabilityCalculatorSections
